export const meddpiccTexts = {
  title: 'MEDDPICC Methodology',
  description: `The MEDDPICC methodology plugin seamlessly integrates essential fields into your environment, acting as checkpoints between stages you define for a structured qualification process. Already using MEDDPICC fields? No worries! Our field mapper effortlessly aligns Sweep's fields with your existing ones, ensuring a smooth transition.`,
};
